<template>
  <div class="lab-page">
    <ActionLoader
      v-if="isLoading"
      class="lab-page__loader"
      name="ball-clip-rotate"
      :size="2"
    />
    <template v-else>
      <SkillDiveLab
        v-if="isSkillDive"
        :parentContext="parentContext"
        @start-issue="startIssue"
      />
      <LabModal
        v-else
        :parentContext="parentContext"
        @prev-route="goToPrevRoute"
        @start-issue="startIssue"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import LabModal from './LabModal.vue'
import SkillDiveLab from './SkillDiveLab.vue'
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/helpers/localStorage'
import CONSTANTS from '@/constants'

export default {
  name: 'LabPage',
  components: {
    LabModal,
    SkillDiveLab,
    ActionLoader,
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      if (from && from.path) {
        setLocalStorage('prevRoute', from.path)
      }
    })
  },
  props: {
    context: {
      type: String,
      default: () => '',
    },
  },
  data: () => {
    return {
      isLoading: false,
      parentId: '',
    }
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
    }),
    parentContext() {
      return {
        id: this.parentId,
        type: this.context,
      }
    },
    isSkillDive() {
      return (
        this.currentLab.is_lab_experience &&
        this.context !== CONSTANTS.PARENT_CONTENT_TYPES_KEYS.COURSE
      )
    },
  },
  async created() {
    this.getRunningLab()
    await this.setParentContext()
    await this.fetchCurrentLab()
  },
  methods: {
    ...mapActions('labs', ['getLabById', 'getRunningLab']),
    ...mapActions('courses', ['getCourseById']),
    ...mapActions('content', ['saveContentIssue']),
    ...mapMutations({
      setParentContent: 'content/CURRENT_PARENT',
    }),
    async setParentContext() {
      const { COURSE } = CONSTANTS.PARENT_CONTENT_TYPES_KEYS
      const parentId = this.$route.params.id
      const isShortUUID = parentId && !parentId.includes('-')
      const isCourse = this.context === COURSE

      if (isCourse && isShortUUID) {
        const course = await this.getCourseById(parentId)
        if (course) {
          this.parentId = course.id
        } else {
          this.goToPrevRoute()
        }
      } else if (parentId) {
        this.parentId = parentId
      }

      this.setParentContent(this.parentContext)
    },
    goToPrevRoute() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        const storagedPrevRoute = getLocalStorage('prevRoute')
        const prevRoute = storagedPrevRoute || '/'
        removeLocalStorage('prevRoute')
        this.$router.replace(prevRoute)
      }
    },
    async fetchCurrentLab() {
      try {
        this.isLoading = true
        const payload = {
          id: this.$route.params.labId,
          parentId: this.parentContext.id,
          parentType: this.parentContext.type,
        }
        await this.getLabById(payload)

        this.isLoading = false
      } catch (e) {
        this.goToPrevRoute()
      }
    },
    startIssue() {
      this.saveContentIssue({
        parent_id: this.parentContext.id,
        parent_type: this.parentContext.type,
        content_type: CONSTANTS.CONTENT_TYPES.LAB,
        content_subtype: this.currentLab.lab_type,
        content_name: this.currentLab.name,
        content_id: this.currentLab.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.lab-page {
  /* width: 100%; */
  min-height: 100vh;
  background-image: url('../assets/images/backgrounds/skill-dive-bg2.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
